import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useFormik } from "formik";
import * as yup from "yup";
import { AuthWrapper } from "../../../components/AuthWrapper/AuthWrapper";
import InputField from "../../../components/Controls/Input/Input";
import { useDispatch, useSelector } from "react-redux";
import {
  oTPLoginRequest,
  forgetPasswordRequest,
  resendOTPRequest,
} from "../../../store/authentication/actions";
import { ButtonComponent } from "../../../components/Controls/Button/Button";
import "./otp.scss";
import Spinner from "../../../components/Spinner/Spinner";
import { decodeUserNameAndPass } from "../../../utils/Constants";
import { counterSeconds } from "../../../utils/Shared";
import CountdownTimer from "../../../components/CountdownTimer/countdownTimer";

const OTP = ({ intl: { messages }, inDialog, handleCancel }) => {
  const loader = useSelector((state) => state.loader);
  const dispatch = useDispatch();
  const todo = localStorage.getItem("todo");
  const encodedString = localStorage.getItem("encodedString");
  const decodedString = decodeUserNameAndPass(encodedString);
  const expirationDate =
    useSelector((state) => state.auth?.expirationDate?.expired_at) ||
    localStorage.getItem("expirationDate");
  const [seconds, setSeconds] = useState("");

  const otpSchema = yup.object().shape({
    otp_code: yup
      .string()
      .min(4, messages.auth.errors.otp)
      .max(4, messages.auth.errors.otp)
      .required(messages.auth.errors.required),
  });

  const formik = useFormik({
    initialValues:
      todo === "forget_password" || todo === "reset_password"
        ? {
            otp_code: "",
            username: decodedString
              .split("[userName]")[1]
              .split("[password]")[0],
          }
        : {
            otp_code: "",
            username: decodedString
              .split("[userName]")[1]
              .split("[password]")[0],
            password: decodedString.split("[password]")[1],
            required_otp: true,
          },
    validationSchema: otpSchema,
    onSubmit: (values) => {
      if (todo === "forget_password" || todo === "reset_password") {
        dispatch(forgetPasswordRequest(values));
      } else {
        dispatch(oTPLoginRequest(values));
      }
    },
  });

  useEffect(() => {
    counterSeconds(expirationDate, setSeconds);
  }, [expirationDate]);

  const handleResend = () => {
    dispatch(
      resendOTPRequest({
        username: decodedString.split("[userName]")[1].split("[password]")[0],
        location: inDialog ? "profile" : "login",
      })
    );
  };

  const renderFormContent = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', height: 'calc(100% - 35px)' }}>
        <div className="otp-form" style={{ width: '100%'}} >
          {!inDialog && <div className="otp-form_logo"></div>}
          <div
            className={inDialog ? "otp-form_mobile mt-4" : "otp-form_mobile"}
          ></div>
          <h4 className="otp-form_form-header">{messages.auth.otpTitle}</h4>
          <p className="otp-form_form-content">{messages.auth.otpContent}</p>
          <div style={{ width: '200px', margin: '0 auto'}}>
            <CountdownTimer
              seconds={isNaN(seconds) ? 0 : seconds}
              handleResend={handleResend}
              expirationDate={expirationDate}
            />
          </div>
          <form onSubmit={formik.handleSubmit}>
            <InputField
              id="otp_code"
              name="otp_code"
              value={formik.values.otp_code}
              onChange={formik.handleChange}
              error={formik.touched.otp_code && Boolean(formik.errors.otp_code)}
              helperText={formik.touched.otp_code && formik.errors.otp_code}
              placeholder={messages.auth.placeholders.otp}
            />
            {inDialog ? (
              <div className="d-flex justify-content-center">
                <ButtonComponent
                  content={
                    <>
                      {loader ? <Spinner color={"white"} /> : messages.auth.send}
                    </>
                  }
                  variant="contained"
                  classes="mx-2 px-5 my-1 form-submit-btn"
                  handleClick={formik.handleSubmit}
                  color="primary"
                />
                <ButtonComponent
                  content={messages.common.cancel}
                  variant="outlined"
                  classes="mx-2 px-5 my-1 form-submit-btn"
                  handleClick={handleCancel}
                  color="primary"
                />
              </div>
            ) : (
              <ButtonComponent
                content={
                  <>{loader ? <Spinner color={"white"} /> : messages.auth.send}</>
                }
                variant="contained"
                classes="mx-auto w-100 my-1 form-submit-btn"
                handleClick={formik.handleSubmit}
                color="primary"
              />
            )}
          </form>
        </div>
      </div>
    );
  };

  return inDialog ? (
    renderFormContent()
  ) : (
    <AuthWrapper
      content={renderFormContent()}
      handleSubmit={formik.handleSubmit}
    />
  );
};

export default injectIntl(OTP);
